import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig } from '@ngx-formly/core';
import { CardContentComponent } from '../../component/card-content/card-content.component';

interface CardContentFieldOptions extends FormlyFieldProps {
  icon?: string;
  currency?: string;
  calculation?: string;
  calculationFunction?: string;
  evaluatedCalculationFunction?: any;
  periodName?: string;
  title?: string;
  detailedCalculation?: [
    {
      label: string;
      value: number;
    },
  ];
  calculationSummary?: {
    label: string;
    value: number;
  };
}
@Component({
  selector: 'app-card-content-field',
  imports: [CommonModule, CardContentComponent],
  templateUrl: './card-content-field.component.html',
  styleUrl: './card-content-field.component.scss',
})
export class CardContentFieldComponent
  extends FieldType<FieldTypeConfig<CardContentFieldOptions>>
  implements OnInit
{
  public ngOnInit(): void {
    if (this.props.calculationFunction) {
      this.props.evaluatedCalculationFunction = eval(
        this.props.calculationFunction
      );
    }
  }
}
